'use strict';

var _ = require('lodash');

function runMultiple(callbacks) {
  return function () {
    var _this = this;

    // eslint-disable-next-line prefer-rest-params
    var args = arguments;

    _.forEach(callbacks, function (callback) {
      callback.apply(_this, args);
    });
  };
}

module.exports = {
  runMultiple: runMultiple
};
//# sourceMappingURL=functionUtils.js.map